import React from 'react'

import App from 'App'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from 'routes'
import { IS_APP, IS_DEV_ENV, setDarkMode } from 'common'

import { TrackData } from '@interco/track'

const DARK_BG = '#0f1115'
const LIGHT_BG = '#ffffff'

const applyInitialBackground = () => {
  if (typeof window === 'undefined') return
  const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const backgroundColor = isDark ? DARK_BG : LIGHT_BG
  document.documentElement.style.backgroundColor = backgroundColor
  document.body.style.backgroundColor = backgroundColor
  document.getElementById('root')?.style.setProperty('background-color', backgroundColor)
}

async function enableMocking() {
  applyInitialBackground()
  setDarkMode()

  if (!IS_DEV_ENV || IS_APP) return Promise.resolve()

  const { worker } = await import('./mocks/browser')

  return worker.start({
    onUnhandledRequest: 'bypass',
  })
}

enableMocking().then(() => {
  TrackData.initOrUpdate({
    runtimeEnv: 'production',
    projectName: 'FRONTEND_CENTRAL_PRIVACIDADE',
    allowLocalHost: false,
  })

  createRoot(document.getElementById('root') as Element).render(
    <App>
      <RouterProvider router={router} />
    </App>,
  )
})
